import { createApp, configureCompat } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import './assets/base.css'
import './utils/rem'
import Breadcrumb from '@/views/Home/Breadcrumb.vue'
import TitleTool from '@/components/TitleTool/index.vue'
import FooterData from '@/views/Home/FooterData.vue'
import GsSelect from '@/components/GsSelect/index.vue'
import GsDate from '@/components/GsDate/index.vue'
import GsSkeleton from '@/components/GsSkeleton/index.vue'
import GsMore from '@/components/GsMore/index.vue'
import GsRegionSelect from '@/components/GsRegionSelect/index.vue'
import GsVal from '@/components/GsVal/index.vue'
import GsMediaPh from '@/components/GsMediaPh/index.vue'
import { setupExternalLinks } from '@/utils/externalLink'

const compatConfig = {
  MODE: 2,
  // Element Plus 的 IsolatedRenderer 是 Vue3 函数组件，不能按 Vue2 async/functional 转
  COMPONENT_FUNCTIONAL: false,
  COMPONENT_ASYNC: false,
}

configureCompat(compatConfig)

setupExternalLinks()

const app = createApp(App)
app.config.compatConfig = compatConfig
app.use(store)
app.use(router)
app.use(ElementPlus, { locale: zhCn })
// Element Plus 走 Vue3 的 modelValue。兼容模式会把 modelValue 改成 value，
// 输入框拿到的一直是空字符串，所以聚焦时打出来的字会被立刻清掉。
Object.keys(app._context.components).forEach((name) => {
  if (!/^El[A-Z]/.test(name)) return
  const comp = app._context.components[name]
  if (!comp || (typeof comp !== 'object' && typeof comp !== 'function')) return
  comp.compatConfig = Object.assign({}, comp.compatConfig, { COMPONENT_V_MODEL: false })
})
app.component('Breadcrumb', Breadcrumb)
app.component('TitleTool', TitleTool)
app.component('FooterData', FooterData)
app.component('GsSelect', GsSelect)
app.component('GsDate', GsDate)
app.component('GsSkeleton', GsSkeleton)
app.component('GsMore', GsMore)
// 三级行政区划选择器全局注册：异步路由分包里按需 import 会出现
// 「GsRegionSelect is not defined」的模块求值顺序问题，改成全局注册最稳。
app.component('GsRegionSelect', GsRegionSelect)
// 预览等独立页面也要用到的通用展示组件，统一全局注册
app.component('GsVal', GsVal)
app.component('GsMediaPh', GsMediaPh)
app.config.errorHandler = (err, instance, info) => {
  const msg = (err && err.message) || ''
  if (msg.includes('ResizeObserver loop')) return
  console.error(err, info)
}
window.addEventListener('error', (event) => {
  const msg = (event && event.message) || ''
  if (msg.includes('ResizeObserver loop')) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
})
app.mount('#app')
